

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"d":"M16.125 6.75L9.875 13L16.125 19.25","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}, []), "\n"]);
};

        